"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Windows95 = function Windows95(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.713 1.596l-.756.068-.238.55.734-.017.26-.601zm1.39.927l-.978.137-.326.807.96-.12.345-.824zM4.89 3.535l-.72.05-.24.567.721-.017.239-.6zm3.724.309l-1.287.068-.394.961 1.27-.053.411-.976zm1.87.566l-1.579.069-.566 1.357 1.596-.088.548-1.338zm-4.188.037l-.977.153-.343.806.976-.12.344-.839zm6.143.668l-1.87.135-.636 1.527 1.87-.154.636-1.508zm2.925.219c-.11 0-.222 0-.334.002l-.767 1.851c1.394-.03 2.52.088 3.373.38l-1.748 4.2c-.955-.304-2.082-.444-3.36-.394l-.539 1.305a8.762 8.762 0 013.364.396l-1.663 4.014c-1.257-.27-2.381-.395-3.386-.344l-.782 1.887c3.362-.446 6.347.822 9.008 3.773L24 9.23c-2.325-2.575-5.2-3.879-8.637-3.896zm-.644.002l-2.024.12-.687 1.68 2.025-.189.686-1.611zm-10.602.05l-.719.036-.224.566h.703l.24-.601zm3.69.397l-1.287.069-.395.959 1.27-.05.412-.978zM5.54 6.3l-.994.154-.344.807.979-.121.359-.84zm4.137.066l-1.58.069L7.53 7.77l1.596-.085.55-1.32zm1.955.688l-1.871.135-.635 1.527 1.887-.154.619-1.508zm2.281.19l-2.01.136-.7 1.682 2.04-.19.67-1.629zm-10.568.066l-.739.035-.238.564h.719l.258-.6zm3.705.293l-1.303.085-.394.961 1.287-.035.41-1.011zm11.838.255a6.718 6.718 0 012.777 1.717l-1.75 4.237c-.617-.584-1.15-.961-1.611-1.149l-1.201-.498 1.785-4.307zM4.734 8.22l-.976.154-.344.807.961-.12.36-.841zm4.186 0l-1.594.052-.549 1.354 1.594-.086.549-1.32zm1.957.668L8.99 9.04l-.619 1.508 1.87-.135.636-1.527zm2.246.275l-2.006.12-.703 1.665 2.041-.156.668-1.629zm-10.602.104l-.718.033-.24.549.718-.016.24-.566zm3.725.273l-1.289.07-.41.961 1.287-.03.412-1zm1.87.6l-1.596.05-.55 1.356 1.598-.084.547-1.322zm-4.186.037l-.979.136-.324.805.959-.119.344-.822zm6.14.633l-1.87.154-.653 1.527 1.906-.154.617-1.527zm2.266.275l-2.025.12-.686 1.663 2.025-.172.686-1.611zm-10.568.031l-.739.037-.238.565.72-.016.257-.586zm3.673.362l-1.289.068-.41.978 1.305-.05.394-.996zm-2.285.533l-.976.154-.326.805.96-.12.342-.84zm4.153.07l-1.596.066-.565 1.356 1.612-.084.549-1.338zm1.957.666l-1.889.154-.617 1.526 1.886-.15.62-1.53zm2.28.223l-2.025.12-.685 1.665 2.041-.172.67-1.613zM.962 13.02l-.738.053-.223.567.72-.02.24-.6zm3.705.31l-1.285.07-.395.976 1.287-.05.393-.997zm11.922.07c1.08.29 2.024.821 2.814 1.613l-1.715 4.183c-.892-.754-1.82-1.32-2.814-1.664l1.715-4.133zm-10.035.515L4.957 14l-.549 1.32 1.578-.066.567-1.338zm-4.184.014l-.996.156-.309.789.961-.105.344-.84zm6.14.67l-1.904.154-.617 1.527 1.889-.154.633-1.527zm2.231.324l-2.025.123-.686 1.682 2.026-.174.685-1.631zm-6.863.328l-1.3.068-.397.979 1.285-.053.412-.994zm1.871.584l-1.578.068-.566 1.334 1.595-.064.549-1.338zm1.953.701l-1.867.137-.635 1.51 1.87-.137.632-1.51zm2.23.31l-2.005.122-.703 1.68 2.04-.19.669-1.611Z"
  }));
};

Windows95.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Windows95.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Windows95;
exports["default"] = _default;